import { DatePickerView } from '@mui/lab/DatePicker/shared';
import { DateTime } from 'luxon';
import { defaultChoicePickerState } from 'shell/components/shared/choice-date/constants';

export const choiceDatePDFFormatter = (
  date: DateTime | null | undefined,
  choice: Array<DatePickerView> = defaultChoicePickerState
): string | undefined => {
  if (choice.includes('month') && choice.includes('year') && !choice.includes('day')) {
    return date?.toFormat('--/MM/yyyy');
  }
  if (!choice.includes('month') && choice.includes('year') && !choice.includes('day')) {
    return date?.toFormat('--/--/yyyy');
  }
  return date?.toFormat('dd/MM/yyyy');
};
